const balanceRemaining = (state = 0, action) => {
    switch(action.type) {
        case 'balanceRemaining':
            return action.payload;
        default:
            return state;
    }
}

export default balanceRemaining;